export const CommonActionTypes = {
  SET_BRANCHES: "SET_BRANCHES",
  SET_VARIETIES: "SET_VARIETIES",
  SET_BAGTYPE: "SET_BAGTYPE",
  SET_DIVISION: "SET_DIVISION",
  SET_CROPS: "SET_CROPS",
  SET_HUBS: "SET_HUBS",
  SET_REFETCH: "SET_REFETCH",
  SET_REBATES: "SET_REBATES",
  SET_SELECTED_CROP: "SET_SELECTED_CROP",
  SET_SELECTED_BRANCH: "SET_SELECTED_BRANCH",
  SET_SELECTED_MULTIBRANCH: "SET_SELECTED_MULTIBRANCH",
  SET_BYPASS_BD: "SET_BYPASS_BD",
  SET_SAUDHA_SCREEN: "SET_SAUDHA_SCREEN",
  SET_PO_SCREEN: "SET_PO_SCREEN",
  SET_SAUDA_DETAILS: "SET_SAUDA_DETAILS",
  SET_CURRENT_PAGE: "SET_CURRENT_PAGE",
  SET_VIEW_AUCTION_PAGE: "SET_VIEW_AUCTION_PAGE",
  SET_SLOT_PAGE: "SET_SLOT_PAGE",
  SET_OPEN_AUCTION_BRANCH: "SET_OPEN_AUCTION_BRANCH",
  SET_BYPASS_ENABLED: "SET_BYPASS_ENABLED",
  SET_TC: "SET_TC",
  SET_DEFAULT_PARAMS: "SET_DEFAULT_PARAMS",
  SET_BRANCH_PARAMS: "SET_BRANCH_PARAMS",
  SET_CROP_PARAMS: "SET_CROP_PARAMS",
  RESET_REDUCER: "RESET_REDUCER",
  SET_PO_PARAMS: "SET_PO_PARAMS",
  SET_START_DATE: "SET_START_DATE",
  SET_END_DATE: "SET_END_DATE",
};
